import Channels from '../../base/channels'

export default class Focus
{
    constructor(view)
    {
        this.view = view
        this.$reference = this.view.querySelector('.jsFocus--view')
        this.$captures = this.view.querySelectorAll('.jsFocus--capture')
        this.$offset = this.view.querySelector('.jsFocus--offset')
        this.funcSizer = this.resize.bind(this)
        this.dimensions = { width : 1145 , height : 660 }
    }

    destroy()
    {
        Channels.removeListener('window::smartresize',this.funcSizer)
    }

    events()
    {
        Channels.on('window::smartresize',this.funcSizer)

    }

    resize()
    {
        this.sizeFocus()
    }

    sizeFocus()
    {
        this.$reference.removeAttribute('style')

        const ratio = this.dimensions.width / this.dimensions.height
        const getWidth = this.$reference.getBoundingClientRect().width
        const setHeight = Math.round(getWidth / ratio)
        const offsetHeight = this.$offset.getBoundingClientRect().height

        this.$reference.style.height = `${setHeight}px`
        for(let i = 0; i < this.$captures.length; i++) {
            const $capture = this.$captures[i]
            $capture.style.height = `${setHeight + offsetHeight}px`
        }

    }

    setup()
    {
        this.sizeFocus()
        this.events()
    }
}